import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';
import { SkeletonLoader } from '@/components/SkeletonLoader/SkeletonLoader';

export const OverviewBox = styled.div`
  display: flex;
  gap: 20px;
  flex-direction: row;
  justify-content: space-between;
  background: ${({ theme }) => theme.palette.primary.background};
  border-radius: 21px;
  padding: 30px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: column;
    padding: 20px 15px;
  }
`;

export const OverviewInfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
`;

export const Item = styled(Typography.Body)`
  white-space: nowrap;
`;

export const DotIcon = styled(IconBox).attrs({ $filename: 'dot.svg' })``;

export const Name = styled(Typography.Body)`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const AdvertiseSkeleton = styled(SkeletonLoader)`
  height: 44px;
  width: 168px;
  border-radius: 14px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 100%;
  }
`;
